<template>
  <div style="width: 100%; margin: 0 auto">
    <!-- 头部 -->
    <div class="body_top">
      <div class="bg_img_div">
        <!-- <img src="../../assets/newZPgb2.png" /> -->
      </div>
      <!-- 绝对定位 -->
      <div class="body_top_abs">
        <div class="img_he">
          <img class="log_Img" :src="require('@/assets/herder_logo1.png')" alt="" />
        </div>
        <p class="bt1">整合山西优秀资源 让作品更高效</p>
        <div class="body_top_abs_gn">
          <div class="BTLS_list">
            <div v-for="index in BTLS_list" @click="BTLS_listClick(index)" :key="index" :class="index.checked == true ? 'BTLS_listY cur' : 'BTLS_listN cur'
              ">
              {{ index.title }}
            </div>
          </div>
          <div class="ag_l">
            <div class="ss_abs_c_srk">
              <input v-model="keyword" @keyup.enter="clikc_ss" placeholder="输入名称进行搜索" />
              <div class="cur" @click="clikc_ss">
                <img src="../../assets/yxsc_ss.png" />
                搜索
              </div>
            </div>
          </div>
          <div class="log_box">
            <!-- <img src="@/assets/log1.png" />
            <p>x</p>
            <img src="@/assets/log2.png" />
            <p>x</p>
            <img src="@/assets/log3.png" /> -->
          </div>
        </div>
      </div>

      <!-- <p class="bt1">整合山西优秀视频资源 让作品更高效</p> 
          <div class="body_top_abs_gn">
          <div class="BTLS_list">
            <div
              v-for="index in BTLS_list"
              @click="BTLS_listClick(index)"
              :key="index"
              :class="
                index.checked == true ? 'BTLS_listY cur' : 'BTLS_listN cur'
              "
            >
              {{ index.title }}
            </div>
          </div>
          <div class="ag_l">
            <div class="ss_abs_c_srk">
              <input
                v-model="keyword"
                @keyup.enter="clikc_ss"
                placeholder="输入名称进行搜索"
              />
              <div class="cur" @click="clikc_ss">
                <img src="../../assets/yxsc_ss.png" />
                搜索
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>

    <div class="body_main" style="padding-bottom: 24px;">
      <!-- 分类列表 -->
      <div class="body_main_classify">
        <el-row :gutter="20">
          <el-col :span="options.length >= 4 ? 6 : 12" v-for="(index, arrI) in options" :key="index">
            <div>
              <div class="bm_classifyTitle">
                {{ index.name }}
              </div>
              <div class="body_main_classify_span">
                <span :style="options.length < 4 ? 'flex: 0 0 16.6%;' : 'flex: 0 0 25%;'
                  " @click="classifyClick(index, index2, arrI)" v-for="index2 in index.options" :key="index2"
                  :class="index2.checked == true ? 'directionListY' : ''">{{ index2.name }}
                </span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 数据分类的列表 视频 -->
      <div v-if="moduleNumber == 0">
        <!-- <div v-for="item in "> -->
        <div v-for="(item, index) in videoList" :key="index">
          <div>
            <div class="SL_hotSongwriter">
              <div class="SL_hotSongwriter_title">{{ item.typeName }}</div>
              <div @click="
                allWorksClick('VIDEO', item.typeId, item.typeName, index, index + 1)
                " class="SL_hotSongwriter_click cur">
                查看全部 >
              </div>
            </div>

            <div class="mn_body" v-if="item.dtos.length">
              <div class="mn_b_l" style="display: flex; width: 100%">
                <moduleProvideMaterial v-if="item.dtos.length > 0" :message="item.dtos[0]"
                  style="width: 50%; height: calc(100% - 0.08rem)" :collectIds="collectIds"
                  class="SL_offerMaterialListdiv">
                </moduleProvideMaterial>
                <div class="mn_b_r SL_offerMaterialListdiv_fu">
                  <div v-for="(int, intIndex) in item.dtos.slice(1)" :key="intIndex">
                    <moduleProvideMaterial :message="int" :collectIds="collectIds" class="SL_offerMaterialListdiv">
                    </moduleProvideMaterial>
                  </div>
                </div>
              </div>
            </div>
            <img v-else class="zanwushuju" src="../../assets/zt_zanwushuju.png" />
          </div>
        </div>
        <img v-if="videoList.length == 0" class="zanwushuju" src="../../assets/zt_zanwushuju.png" />
        <!--换接口 -->
        <!-- <div v-for="(item, index) in videoList" :key="index">
          <div>
            <div class="SL_hotSongwriter">
              <div class="SL_hotSongwriter_title">{{ item.name }}</div>
              <div @click="
                allWorksClick('VIDEO', item.id, item.name, index, index + 1)
                " class="SL_hotSongwriter_click cur">
                查看全部 >
              </div>
            </div>

            <div class="mn_body" v-if="item.list.length">
              <div class="mn_b_l" style="display: flex; width: 100%">
                <moduleProvideMaterial v-if="item.list.length > 0" :message="item.list[0]"
                  style="width: 50%; height: calc(100% - 0.08rem)" :collectIds="collectIds"
                  class="SL_offerMaterialListdiv">
                </moduleProvideMaterial>
                <div class="mn_b_r SL_offerMaterialListdiv_fu">
                  <div v-for="(int, intIndex) in item.list1" :key="intIndex">
                    <moduleProvideMaterial :message="int" :collectIds="collectIds" class="SL_offerMaterialListdiv">
                    </moduleProvideMaterial>
                  </div>
                </div>
              </div>
            </div>
            <img v-else class="zanwushuju" src="../../assets/zt_zanwushuju.png" />
          </div>
        </div> -->
        <!-- 换接口 -->
        <!-- <div>
          <div class="SL_hotSongwriter">
            <div class="SL_hotSongwriter_title">AE模板</div>
            <div
              @click="allWorksClick('VIDEO', '', '', '', 2)"
              class="SL_hotSongwriter_click cur"
            >
              查看全部 >
            </div>
          </div>
          <div
            class="mn_body"
            v-if="nameList.AEmb1 != '' || nameList.AEmb.length > 0"
          >
            <div class="mn_b_l" v-if="nameList.AEmb1 != ''">
              <moduleProvideMaterial
                :message="nameList.AEmb1"
                style="width: 100%; height: 100%"
                class="SL_offerMaterialListdiv cur"
              >
              </moduleProvideMaterial>
            </div>
            <div class="mn_b_r" v-if="nameList.AEmb.length > 0">
              <div v-for="index in nameList.AEmb" :key="index">
                <moduleProvideMaterial
                  :message="index"
                  class="SL_offerMaterialListdiv cur"
                >
                </moduleProvideMaterial>
              </div>
            </div>
          </div>
          <img
            v-if="nameList.AEmb.length == 0"
            class="zanwushuju"
            src="../../assets/zt_zanwushuju.png"
          />
        </div>
        <div>
          <div class="SL_hotSongwriter">
            <div class="SL_hotSongwriter_title">背景视频</div>
            <div
              @click="allWorksClick('VIDEO', '', '', '', 3)"
              class="SL_hotSongwriter_click cur"
            >
              查看全部 >
            </div>
          </div>
          <div
            class="mn_body"
            v-if="nameList.bgsp1 != '' || nameList.bgsp.length > 0"
          >
            <div class="mn_b_l" v-if="nameList.bgsp1 != ''">
              <moduleProvideMaterial
                :message="nameList.bgsp1"
                style="width: 100%; height: 100%"
                class="SL_offerMaterialListdiv cur"
              >
              </moduleProvideMaterial>
            </div>
            <div class="mn_b_r" v-if="nameList.bgsp.length > 0">
              <div v-for="index in nameList.bgsp" :key="index">
                <moduleProvideMaterial
                  :message="index"
                  class="SL_offerMaterialListdiv cur"
                >
                </moduleProvideMaterial>
              </div>
            </div>
          </div>
          <img
            v-if="nameList.bgsp.length == 0"
            class="zanwushuju"
            src="../../assets/zt_zanwushuju.png"
          />
        </div>
        <div>
          <div class="SL_hotSongwriter">
            <div class="SL_hotSongwriter_title">视频元素</div>
            <div
              @click="allWorksClick('VIDEO', '', '', '', 4)"
              class="SL_hotSongwriter_click cur"
            >
              查看全部 >
            </div>
          </div>
          <div
            class="mn_body"
            v-if="nameList.spys1 != '' || nameList.spys.length > 0"
          >
            <div class="mn_b_l" v-if="nameList.spys1 != ''">
              <moduleProvideMaterial
                :message="nameList.spys1"
                style="width: 100%; height: 100%"
                class="SL_offerMaterialListdiv cur"
              >
              </moduleProvideMaterial>
            </div>
            <div class="mn_b_r" v-if="nameList.spys.length > 0">
              <div v-for="index in nameList.spys" :key="index">
                <moduleProvideMaterial
                  :message="index"
                  class="SL_offerMaterialListdiv cur"
                >
                </moduleProvideMaterial>
              </div>
            </div>
          </div>

          <img
            v-if="!nameList.spys.length"
            class="zanwushuju"
            src="../../assets/zt_zanwushuju.png"
          />
        </div> -->
      </div>
      <!-- 数据分类的列表 音乐 -->
      <div v-if="moduleNumber == 1">
        <div>
          <div class="SL_hotSongwriter">
            <div class="SL_hotSongwriter_title">发现好音乐</div>
          </div>
          <el-row :gutter="20">
            <el-col :span="12" v-for="index in musicList" :key="index">
              <moduleProvideMaterialMusic :message="index" :collectIds="collectIds" @callback="handleCallback"
                ref="moduleProvideMaterialMusicRef" class="SL_offerMaterialListdiv">
              </moduleProvideMaterialMusic>
              <!--  -->
            </el-col>
          </el-row>
          <img v-if="musicList.length == 0" class="zanwushuju" src="../../assets/zt_zanwushuju.png" />
          <div class="body_bottom cur" @click="allWorksClick('MUSIC')">
            <div>更多好音乐</div>
          </div>
        </div>
      </div>
      <!-- 数据分类的列表 图片 -->
      <div v-if="moduleNumber == 2">
        <!-- 图片列表 -->
        <div v-for="(options_item, options_index) in options" :key="options_item.id">
          <div class="SL_hotSongwriter">
            <div class="SL_hotSongwriter_title">
              {{ options_item.name }}
            </div>
            <div @click="
              allWorksClick(
                'IMAGE',
                options_item.id,
                options_item.name,
                '',
                options_index + 1
              )
              " class="SL_hotSongwriter_click cur">
              查看全部 >
            </div>
          </div>
          <div v-if="options_item.content">
            <img v-if="options_item.content.length == 0" class="zanwushuju" src="../../assets/zt_zanwushuju.png" />

            <div v-else :class="'SL_hotSongwriter_img_box' + Number(options_index + 1)">
              <!-- <div>
                <div :id="options_item.idDom"></div>
              </div> -->
              <div class="item" v-for="(item, index) in options_item.content" :key="index">
                <div :src="item.showImage" @click="img_detail(options_item.content[index].id)"
                  v-if="options_item.content[index]" class="item_" :style="'background-image: url(' +
                    options_item.content[index].showImage +
                    ');'
                    " />
              </div>
            </div>
            <!-- <div
                class="item"
                v-for="(item, index) in Number(options_index + 1) == 1 ? 6 : 8"
                :key="item.id"
              >
                <div
                  @click="img_detail(options_item.content[index].id)"
                  v-if="options_item.content[index]"
                  class="item_"
                  :style="
                    'background-image: url(' +
                      options_item.content[index].showimage ||
                    options_item.content[index].filePath + ');'
                  "
                ></div>
              </div>
              </div> -->
          </div>
        </div>
      </div>
    </div>
    <wavesurfer ref="ShadowMaterialyinyueRef" v-model="isChildVisible" v-bind="bovalue" @stop="MusicOff" @play="MusicOn">
    </wavesurfer>
    <!-- <div class="yinyue">
      <ShadowMaterialyinyue
        v-show="isChildVisible"
        ref="ShadowMaterialyinyueRef"
        :mp3url="bovalue"
        :MusicOff="MusicOff"
      ></ShadowMaterialyinyue>
    </div> -->
    <!-- <a-player :audio="audio" :lrc-type="3"></a-player> -->
    <!-- <a-player></a-player> -->
  </div>
</template>

<script setup>
import { ref, watch, getCurrentInstance, onBeforeUnmount, nextTick } from "vue";
import { useRouter } from "vue-router";
import { Axios } from "../../assets/js/ls_com_axios.js";
import { ElMessage } from "element-plus";
import wavesurfer from '@/components/Wavesurfer/index.vue'
import { WaterFall } from "./WaterFall.js"
// import aplayer from 'vue-aplayer'
// import APlayer from '@moefe/vue-aplayer';
// import ShadowMaterialyinyue from "./ShadowMaterialyinyue.vue";
import moduleProvideMaterial from "../../components/moduleProvideMaterial.vue";
import moduleProvideMaterialMusic from "../../components/moduleProvideMaterialMusic.vue";
document.title = "标识山西-找素材";
// import moduleProvideMaterialImage from "../../components/moduleProvideMaterialImage.vue"
let bgType = ref(2); // 1 图片背景 ，2 视频背景 , 3音乐背景
let w_bgType = ref(localStorage.getItem("ShadowMaterial_bgType")) || 4;
const router = useRouter();

onBeforeUnmount(() => {
  /*
  如果音乐是关闭就不调用
 */
  ShadowMaterialyinyueRef.value.isPlaying.value
    ? ShadowMaterialyinyueRef.value.handleDisplay()
    : "";
});
const audio = {
  name: "东西（Cover：林俊呈）",
  artist: "纳豆",
  url: "https://cdn.moefe.org/music/mp3/thing.mp3",
  cover: 'https://p1.music.126.net/5zs7IvmLv7KahY3BFzUmrg==/109951163635241613.jpg?param=300y300', // prettier-ignore
  lrc: "https://cdn.moefe.org/music/lrc/thing.lrc",
};
const url =
  "https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg";
const urlA = [
  "https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg",
];
// 搜索
const keyword = ref("");
const clikc_ss = function () {
  console.log(keyword.value.vcalue);
  console.log("-----");

  if (keyword.value == "") {
    ElMessage({
      message: "搜索不可为空",
      type: "error",
    });
  } else {
    let typeName = "";
    for (let i = 0; i < BTLS_list.value.length; i++) {
      if (BTLS_list.value[i].checked == true) {
        typeName = BTLS_list.value[i].typeName;
      }
    }
    router.push({
      path: "/ShadowMaterialVideoList",
      query: {
        materialType: typeName,
        inputTitle: keyword.value,
      },
    });
  }
};

/**
 * 分类下拉
 *
 */
const options = ref([]);
//音乐分类

const getMusicClassifyList = function () {
  Axios("get", "/fodder/music-types", {}, false, function (res) {
    options.value = [];
    // 使用方法
    let topItems = findTopItems(res.data.data);
    topItems.shift();
    const refactoredData = modifyJSON(topItems);
    // let deletedObj = refactoredData.shift(); // 删除第一个对象并保存到deletedObj
    // options.value = refactoredData;
    // let obj = refactoredData.shift();
    options.value = refactoredData;

    getMusicData(); // 获取数据
  });
};

const modifyJSON = (data) => {
  let arr = [];

  data.forEach((e) => {
    if (e.isTop === "1") {
      if (e.options) {
        if (e.options.length) {
          e.arr = [];
          e.options.forEach((ie) => {
            if (ie.options) {
              if (ie.options.length) {
                ie.options.forEach((item) => {
                  if (item.isTop === "1") {
                    e.arr.push(item);
                  }
                });
              }
            }
          });
        }
      }
    }
  });
  data.forEach((e) => {
    let obj = {};
    obj.id = e.id;
    obj.createUser = e.createUser;
    obj.isTop = e.isTop;
    obj.name = e.name;
    obj.parentId = e.parentId;
    obj.updateTime = e.updateTime;
    obj.options = e.arr;
    arr.push(obj);
  });
  return arr;
};

// const modifyJSON = (data, limit) => {
//   const modifiedData = [];

//   data.forEach((item) => {
//     if (item.isTop !== "1") {
//       return;
//     }

//     const modifiedOptions = [];
//     item.options.forEach((subOption) => {
//       const subOptions = subOption.options
//         .filter((subSubOption) => subSubOption.isTop === "1")
//         .slice(0, limit);

//       if (subOptions.length > 0) {
//         const modifiedSubOption = {
//           id: subOption.id,
//           name: subOption.name,
//           parentId: subOption.parentId,
//           isTop: subOption.isTop,
//           materialType: subOption.materialType,
//           options: subOptions,
//         };
//         modifiedOptions.push(modifiedSubOption);
//       }
//     });

//     if (modifiedOptions.length > 0) {
//       const modifiedItem = {
//         id: item.id,
//         name: item.name,
//         isTop: item.isTop,
//         materialType: item.materialType,
//         options: modifiedOptions,
//         checked: item.checked,
//       };
//       modifiedData.push(modifiedItem);
//     }
//   });

//   return modifiedData;
// };

// 假设data是包含所有数据的数组
function findTopItems(data) {
  const tree = {};

  for (const material of data) {
    const id = material.id;
    const parentId = material.parentId;

    if (!tree[id]) {
      tree[id] = {
        ...material,
        options: [],
      };
    } else {
      tree[id] = {
        ...material,
        options: tree[id].options,
      };
    }

    if (!tree[parentId]) {
      tree[parentId] = {
        options: [],
      };
    }
    tree[id].checked = false;
    tree[parentId].options.push(tree[id]);
  }

  // 找到根节点并返回
  const roots = Object.values(tree).filter((node) => !node.parentId);
  return roots;
}

// 获取已收藏的ID
// const getTypeIdList = function () {
// Axios('get' , '/fodder/collect/collect-ids' , false , false , function(res) {
// console.log(res.data)
// })
// }
// getTypeIdList()
function buildTreeMusic(materials, list) {
  const tree = {};
  materials.forEach((material) => {
    const id = material.id;
    const parentId = material.parentId;

    if (!tree[id]) {
      tree[id] = {
        ...material,
        options: [],
      };
    } else {
      tree[id] = {
        ...material,
        options: tree[id].options,
      };
    }

    if (!tree[parentId]) {
      tree[parentId] = {
        options: [],
      };
    }
    tree[id].checked = false;
    tree[parentId].options.push(tree[id]);
  });

  // 添加三级数据
  list.forEach((item) => {
    for (let i = 0; i < 4; i++) {
      if (item.parentId === tree[0].options[i].id) {
        tree[0].options[i].options.push(item);
      }
    }
  });

  // 过滤掉isTop为0的元素
  tree[0].options.forEach((option) => {
    option.options = option.options.filter((item) => item.isTop !== 0);
  });

  return tree[0].options;
}
//图片分类
const getImageClassifyList = function () {
  Axios("get", "/fodder/image-types", { isTop: 1 }, false, function (res) {
    options.value = [];
    const tree = buildTree(res.data.data);
    options.value = tree;
    console.log(options, "getImageClassifyList");
    options.value.forEach((item, index) => {
      init_IMAGE(item.id, index);
    });
  });
};
function buildTree(materials) {
  const tree = {};
  materials.forEach((material) => {
    const id = material.id;
    const parentId = material.parentId;

    if (!tree[id]) {
      tree[id] = {
        ...material,
        options: [],
      };
    } else {
      tree[id] = {
        ...material,
        options: tree[id].options,
      };
    }

    if (!tree[parentId]) {
      tree[parentId] = {
        options: [],
      };
    }
    tree[id].checked = false;
    tree[parentId].options.push(tree[id]);
  });

  return tree[0].options;
}

const BTLS_list = ref([
  {
    title: "搜视频",
    url: "",
    checked: true,
    by: "",
    bgType: 2,
    typeName: "VIDEO",
  },
  {
    title: "搜音乐",
    url: "",
    checked: false,
    by: "",
    bgType: 3,
    typeName: "MUSIC",
  },
  {
    title: "搜图片",
    url: "",
    checked: false,
    by: "",
    bgType: 1,
    typeName: "IMAGE",
  },
]);

const moduleNumber = ref(0);
const classifyList = ref([
  {
    title: "实拍视频",
    list: [
      "城市建筑",
      "自然风光",
      "科技网络",
      "餐饮美食",
      "商务金融",
      "医疗健康",
      "智慧交通",
      "三维房产",
    ],
  },
  {
    title: "AE模板",
    list: [
      "片头片尾",
      "logo演绎",
      "文字标题",
      "实拍视频",
      "企业宣传",
      "中国风",
      "大数据",
      "颁奖典礼",
    ],
  },
  {
    title: "AE模板",
    list: [
      "片头片尾",
      "logo演绎",
      "文字标题",
      "实拍视频",
      "企业宣传",
      "中国风",
      "大数据",
      "颁奖典礼",
    ],
  },
  {
    title: "AE模板",
    list: [
      "片头片尾",
      "logo演绎",
      "文字标题",
      "实拍视频",
      "企业宣传",
      "中国风",
      "大数据",
      "颁奖典礼",
    ],
  },
]);

const BTLS_listClick = function (index) {
  for (let i = 0; i < BTLS_list.value.length; i++) {
    if (BTLS_list.value[i] == index) {
      if (i == 0) {
        router.push({
          path: "/ShadowMaterial",
          query: { type: "video" },
        });
      }
      if (i == 1) {
        router.push({
          path: "/ShadowMaterial",
          query: { type: "music" },
        });
      }
      if (i == 2) {
        router.push({
          path: "/ShadowMaterial",
          query: { type: "image" },
        });
      }
      // BTLS_list.value[i].checked = true;
      bgType.value = BTLS_list.value[i].bgType;
      moduleNumber.value = i;
      console.log(moduleNumber.value);
      console.log("moduleNumber.value");

      if (i == 0) {
        getVideoClassifyList();
      }
      if (i == 1) {
        console.log("music---");

        getMusicClassifyList();
      }
      if (i == 2) {
        console.log("获取参数 image");
        getImageClassifyList();
      }
    } else {
      BTLS_list.value[i].checked = false;
    }
  }
  isChildVisible.value = false;
  if (bgType.value != 3) isChildVisible.value = false;
  return;
};
/**
 * @param {Object} type
 * 点击类型    图片、视频、音频跳转列表
 */
const classifyClick = function (index, index2, arrI) {
  for (let i = 0; i < index.options.length; i++) {
    if (index.options[i] == index2) {
      index.options[i].checked = true;
    } else {
      index.options[i].checked = false;
    }
  }
  allWorksClick(index2.materialType, index2.id, index2.name, arrI, arrI + 1);
};
/**
 * @param {Object} type
 * @param {Object} typeIds
 * @param {Object} typeIdsName
 * @param {Object} arrI   分类一级下标
 * 图片、视频、音频全部跳转
 */

const allWorksClick = function (type, typeIds, typeIdsName, arrI, title) {
  if (typeIds == 3) {
  }
  router.push({
    path: "/ShadowMaterialVideoList",
    query: {
      materialType: type,
      typeIds: typeIds,
      typeIdsName: typeIdsName,
      index: arrI,
      title,
    },
  });
};

/**
 * @param {Object} index
 * 视频详情跳转
 */
// const goParticulars = function(index) {
// 	console.log(index.id)
// 	router.push({
// 		path: '/ShadowMaterialVideoParticulars',
// 		query: {
// 			id: index.id
// 		}
// 	})
// }
// const goMusic = function() {
// 	router.push({
// 		path: '/ShadowMaterialVideoMusic',
// 		query : {
// 			id :
// 		}
// 	})
// }

/* 分类的拼接 */
const classifyPJ = function () {
  let classifyTitle = [];
  for (let i = 0; i < options.value.length; i++) {
    let options2 = options.value[i].options;
    for (let j = 0; j < options2.length; j++) {
      if (options2.checked == true) {
        classifyTitle.push(options2.id);
      }
    }
  }
  let returnTitle = "";
  if (classifyTitle.length > 0) {
    returnTitle = classifyTitle.join(",");
  }
  return returnTitle;
};
//视频分类
let videoList = ref([]);
const getVideoClassifyList = function () {
  Axios("get", "/fodder/video-types", { isTop: 1 }, false, function (res) {
    options.value = [];
    const tree = buildTree(res.data.data);
    options.value = tree;
    Axios("get", "/fodder/manage/webMList", {}, false, function (res) {
      if (res.data.code == 200) {
        videoList.value = res.data.data;
      }
    })
  })

  // --------------更换接口------------
  // Axios("get", "/fodder/video-types", { isTop: 1 }, false, function (res) {
  //   options.value = [];
  //   const tree = buildTree(res.data.data);
  //   console.log(tree);
  //   options.value = tree;
  //   let arr = [];
  //   tree.forEach((e, index) => {
  //     // console.log(e);
  //     arr.push({ id: e.id, name: e.name, list: [] });
  //   });
  //   videoList.value = arr;
  //   videoList.value.forEach((e, index) => {
  //     Axios(
  //       "get",
  //       "/fodder/front/list",
  //       {
  //         materialType: "VIDEO", // 类型
  //         typeIds: e.id,
  //         status: 1, // 审核状态
  //         pageIndex: 1,
  //         pageSize: 5,
  //       },
  //       false,
  //       function (res) {
  //         e.list = res.data.rows;
  //         let arr1 = [];
  //         if (res.data.rows.length > 1) {
  //           arr1 = [...res.data.rows];
  //           arr1.shift(); // Remove the first element
  //           e.list1 = arr1;
  //         } else {
  //           e.list1 = [];
  //         }
  //       }
  //     );
  //   });
  // });
  // --------------更换接口------------
  // getVideoDataBgsp("背景视频");
  // getVideoDataSpys("视频元素");
  // getVideoDataSpsp("实拍视频");
  // getVideoDataAEmb("AE模板");
};

// 视频跳转
const goParticulars = function (index) {
  router.push({
    path: "/ShadowMaterialVideoParticulars",
    query: {
      id: index.id,
    },
  });
};
const nameList = ref({
  // 需要展示的数据列表
  spsp: [],
  spsp1: [],
  AEmb: [],
  AEmb1: [],
  bgsp: [],
  bgsp1: [],
  spys: [],
  spys1: [],
});
// 公共获取指定类型的数据
/* 公共获取视频的数据 -背景视频 */
const getVideoDataBgsp = function (name = "背景视频") {
  let typeIds = "";
  for (let i = 0; i < options.value.length; i++) {
    if (options.value[i].name == name) {
      typeIds = options.value[i].id;
    }
  }
  let params = {
    materialType: "VIDEO", // 类型
    // memberId: null, // 会员id
    status: 1, // 审核状态
    pageIndex: 1,
    pageSize: 5,
  };
  params["typeIds"] = "";
  if (classifyPJ() != "") {
    params["typeIds"] = classifyPJ();
  }
  if (typeIds) {
    params["typeIds"] = params["typeIds"] + typeIds;
  }
  // '/fodder/front/index'
  Axios("get", "/fodder/front/list", params, false, function (res) {
    nameList.value.bgsp = res.data.rows;
    nameList.value.bgsp = nameList.value.bgsp.slice(1);
    nameList.value.bgsp1 = res.data.rows[0];
  });
};
/* 公共获取视频的数据 -视频元素 */
const getVideoDataSpys = function (name = "视频元素") {
  let typeIds = "";
  for (let i = 0; i < options.value.length; i++) {
    if (options.value[i].name == name) {
      typeIds = options.value[i].id;
    }
  }
  let params = {
    materialType: "VIDEO", // 类型
    // memberId: null, // 会员id
    status: 1, // 审核状态
    pageIndex: 1,
    pageSize: 5,
  };
  params["typeIds"] = "";
  if (classifyPJ() != "") {
    params["typeIds"] = classifyPJ();
  }
  if (typeIds) {
    params["typeIds"] = params["typeIds"] + typeIds;
  }
  Axios("get", "/fodder/front/list", params, false, function (res) {
    nameList.value.spys = res.data.rows;
    nameList.value.spys = nameList.value.spys.slice(1);
    nameList.value.spys1 = res.data.rows[0];
  });
};
/* 公共获取视频的数据 -实拍视频 */
const getVideoDataSpsp = function (name = "实拍视频") {
  let typeIds = "";
  for (let i = 0; i < options.value.length; i++) {
    if (options.value[i].name == name) {
      typeIds = options.value[i].id;
    }
  }
  let params = {
    materialType: "VIDEO", // 类型
    // memberId: null, // 会员id
    status: 1, // 审核状态
    pageIndex: 1,
    pageSize: 5,
  };
  params["typeIds"] = "";
  if (classifyPJ() != "") {
    params["typeIds"] = classifyPJ();
  }
  if (typeIds) {
    params["typeIds"] = params["typeIds"] + typeIds;
  }
  Axios("get", "/fodder/front/list", params, false, function (res) {
    nameList.value.spsp = res.data.rows;
    nameList.value.spsp = nameList.value.spsp.slice(1);
    nameList.value.spsp1 = res.data.rows[0];
    console.log("  nameList.value", nameList.value);
  });
};
/* 公共获取视频的数据 -AE模板 */
const getVideoDataAEmb = function (name = "AE模板") {
  let typeIds = "";
  for (let i = 0; i < options.value.length; i++) {
    if (options.value[i].name == name) {
      typeIds = options.value[i].id;
    }
  }
  let params = {
    materialType: "VIDEO", // 类型
    // memberId: null, // 会员id
    status: 1, // 审核状态
    pageIndex: 1,
    pageSize: 5,
  };
  params["typeIds"] = "";
  if (classifyPJ() != "") {
    params["typeIds"] = classifyPJ();
  }
  if (typeIds) {
    params["typeIds"] = params["typeIds"] + typeIds;
  }
  Axios("get", "/fodder/front/list", params, false, function (res) {
    nameList.value.AEmb = res.data.rows;
    nameList.value.AEmb = nameList.value.AEmb.slice(1);

    nameList.value.AEmb1 = res.data.rows[0];
  });
};
const musicList = ref([]);
// 素材首页
const getMusicData = function () {
  let params = {
    materialType: "MUSIC", // 类型
    // memberId: null, // 会员id
    status: 1, // 审核状态
    // pageIndex: 1,
    // pageSize: 20
  };
  Axios("get", "/fodder/front/index", params, false, function (res) {
    musicList.value = [];
    musicList.value = res.data.data;
  });
};

//初始化图片
const srcList_type1 = ref([]);
const srcList_type2 = ref([]);

const init_IMAGE = (typeIds, index) => {
  Axios(
    "get",
    "/fodder/front/list",
    {
      // isOnline: 0,
      materialType: "IMAGE",
      paramIndex: 1, //(排序方式（0默认1最新2热门）)
      status: 1,
      typeIds: typeIds,
      pageIndex: 1,
      pageSize: 8,
    },
    false,
    (res) => {
      if (res.data.rows.length == 0) {
        options.value.forEach((item_options, index_options) => {
          options.value[index].content = [];
        });
      } else {
        let new_srcList = res.data.rows;
        options.value[index].content = new_srcList;
        options.value[index].idDom = 'forcenter' + typeIds;
        // console.log(options.value.filter(item => item.id == 'forcentersy')[0], "sss")
        // nextTick(() => {
        //   let mwf_ = new WaterFall({
        //     id: 'forcenter' + typeIds,
        //     imgUrls: new_srcList.map((item: any) => item.showImage),
        //   });
        // });
      }
    }
  );
};
// 图片跳详情
const img_detail = (id) => {
  open("ShadowMaterialVideoImage?id=" + id)
  // router.push({
  //   path: "/ShadowMaterialVideoImage",
  //   query: {
  //     id: id,
  //   },
  // }).then(() => {
  //   location.reload();
  // });
};

// 音乐播放
const isChildVisible = ref(false);
const bovalue = ref("");
const yinyuelist = ref(null);
const ShadowMaterialyinyueRef = ref();
let num = 0;
const moduleProvideMaterialMusicRef = ref();
const MusicOff = (id) => {
  moduleProvideMaterialMusicRef.value.forEach((e) => {
    if (id == e.newData.message.id) {
      e.sendValue2();
    }
  });
};
const MusicOn = (id) => {
  moduleProvideMaterialMusicRef.value.forEach((e) => {
    if (id == e.newData.message.id) {
      e.sendValue3();
    }
  });
};
const getPaymentRequest = async (materialId) => {
  return new Promise(async (resolve, reject) => {
    await Axios(
      "post",
      "/fodder/member-visited",
      {
        materialId: materialId,
      },
      false,
      (res) => {
        resolve(true);
      }
    );
  });
};


const handleCallback = async (material) => {
  if (bgType.value != 3) return;
  if (isChildVisible.value != true) {
    isChildVisible.value = !isChildVisible.value;
  }
  let isSee = true
  const musicRef = moduleProvideMaterialMusicRef.value.find(x => x.newData.message.id === material.id)
  if (!musicRef.runningStatus) {
    ShadowMaterialyinyueRef.value.handleStop()
    isSee = false
  } else if (musicRef.runningStatus && material.id === bovalue.value.id) {
    ShadowMaterialyinyueRef.value.playAudio()
  }
  bovalue.value = material;
  if (isSee) {
    let res = await getPaymentRequest(material.id);
    if (res) {
      nums(material);
    }
  }
};
const nums = (material) => {
  moduleProvideMaterialMusicRef.value.forEach((e) => {
    if (material.id == e.newData.message.id) {
      e.numS1();
    }
  });
};
const collectIds = ref([])
const getCollects = async () => {
  await Axios(
    "get",
    "/fodder/collect/collect-ids",
    {
    },
    false,
    (res) => {
      collectIds.value = res.data.data
    }
  );
}
//数据调用
if (router.currentRoute.value.query.type) {
  if (router.currentRoute.value.query.type == "video") {
    BTLS_list.value[0].checked = true;
    BTLS_list.value[1].checked = false;
    BTLS_list.value[2].checked = false;

    // BTLS_listClick(BTLS_list.value[0]);
  }
  if (router.currentRoute.value.query.type == "image") {
    BTLS_list.value[0].checked = false;
    BTLS_list.value[1].checked = false;
    BTLS_list.value[2].checked = true;
    // BTLS_listClick(BTLS_list.value[2]);
  }
  if (router.currentRoute.value.query.type == "music") {
    BTLS_list.value[0].checked = false;
    BTLS_list.value[1].checked = true;
    BTLS_list.value[2].checked = false;
    // BTLS_listClick(BTLS_list.value[1]);
  }
}
// getVideoClassifyList();
watch(
  () => router.currentRoute.value.query.type,
  (newData, oldData) => {
    if (router.currentRoute.value.query.type == "video") {
      BTLS_list.value[0].checked = true;
      BTLS_list.value[1].checked = false;
      BTLS_list.value[2].checked = false;

      BTLS_listClick(BTLS_list.value[0]);
    }
    if (router.currentRoute.value.query.type == "image") {
      BTLS_list.value[0].checked = false;
      BTLS_list.value[1].checked = false;
      BTLS_list.value[2].checked = true;
      BTLS_listClick(BTLS_list.value[2]);
    }
    if (router.currentRoute.value.query.type == "music") {
      BTLS_list.value[0].checked = false;
      BTLS_list.value[1].checked = true;
      BTLS_list.value[2].checked = false;
      BTLS_listClick(BTLS_list.value[1]);
    }
  },
  {
    deep: true, //ref需要手动开启，reactive则不用主动开启 源码中是默认开启的
    immediate: true, //默认一进来就开启执行一次
    // flush: "pre", //pre-组件更新之前调用  sync-同步执行   post-组件更新之后执行
  }
);
getCollects();
</script>

<style scoped lang="less">
.mn_body {
  display: flex;
  justify-content: flex-start;
  // height: 3.65rem;
}

.mn_b_l {
  width: 50%;
  height: 3.52rem;
  padding-right: 0.16rem;
  margin-bottom: 0.3rem;
}

.mn_b_r {
  width: 50%;
  display: flex;
  flex-wrap: wrap;
}

.mn_b_r>div {
  width: 50%;
  height: 50%;
}

.yinyue {
  position: fixed;
  bottom: 0;
  // height: 100px;
  width: 100%;
  // background: #FF6000;
  z-index: 999;
}

.zanwushuju {
  width: 4rem;
  display: block;
  margin: 0 auto;
}

/deep/.custom-video-player,
/deep/.video-js {
  width: 100% !important;
  /* height: 6.3rem !important; */
}

::v-deep .video-js .vjs-tech {
  object-fit: fill;
}

::v-deep .vjs-poster {
  background-size: cover;
}

.bg_img_div {
  width: 100%;
  position: relative;
  // z-index: -1;
  // background: rgba(0, 0, 0, 0.3);
  height: 7rem;
  // overflow: hidden;
  background: url("../../assets/newZPgb2.png") no-repeat bottom center;
  background-size: auto 100%;
}

video,
.bg_img_div>img {
  width: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  /* 50%为自身尺寸的一半 */
}

.SL_offerMaterialListdiv_fu {
  // :nth-child(1) {
  //   margin-bottom: 0.1rem;
  // }
  // :nth-child(2) {
  //   margin-bottom: 0.1rem;
  // }
}

.SL_offerMaterialListdiv {
  transition: all 0.5s;
  width: 3.02rem;
  height: calc(100% - 0.1rem);
  background: rgba(0, 0, 0, 0.3);
  position: relative;
  // margin-bottom: 0.1rem;
  margin-left: 0.1rem;
  display: block;
  overflow: hidden;
  border-radius: 0.12rem;
}

.body_top {
  margin: 0 auto;
  position: relative;
  background: rgba(0, 0, 0, 0.3);
}

.body_top_abs {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
}

.body_top_abs>.img_he {
  width: 100%;
  text-align: center;
  margin-top: 1.3rem;
}

.log_Img {
  text-align: center;
  width: 2.8rem;
}

.body_top_abs_gn {
  flex: 1;
  position: relative;
  width: 7.5rem;
  margin: 0 auto;
  margin-top: 0.9rem;
}

.ag_select {
  margin-bottom: 0.12rem;
}

.ag_select>span {
  margin-right: 0.4rem;
  color: #fff;
  font-size: 0.14rem;
  line-height: 0.16rem;
  padding-bottom: 0.03rem;
}

.ag_selectT {
  border-bottom: 0.02rem solid #fff;
}

.ag_selectY {
  border-bottom: 0.02rem solid rgba(0, 0, 0, 0);
}

.ag_l {
  width: 100%;
  display: flex;
  justify-content: initial;
  align-items: center;
  margin-top: 0.12rem;
}

.ss_abs_c_srk {
  width: 8rem;
  display: flex;
  overflow: hidden;
  border-radius: 0.08rem;
}

.ss_abs_c_srk>input {
  flex-grow: 1;
  font-size: 0.14rem;
  border: 0rem solid #fff;
  padding: 0.16rem;
}

.ss_abs_c_srk>div {
  font-size: 0.14rem;
  color: #ffffff;
  background: #C01A26;
  padding: 0.16rem 0.24rem;
  display: flex;
  align-items: center;
}

.ss_abs_c_srk>div>img {
  width: 0.16rem;
  margin-right: 0.06rem;
}

.ss_abs_c_srk>div>input {
  border: 0rem solid #fff;
  background: #fff;
}

.body_top {
  width: 100%;
  position: relative;
}

.body_top_list {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.bt1 {
  margin-top: 0.1rem;
  color: #ffffff;
  font-size: 0.3rem;
  text-align: center;
}

.bt2 {
  margin-top: 0.08rem;
  font-size: 0.16rem;
  color: #ffffff;
  text-align: center;
}

.log_box {
  position: absolute;
  bottom: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 0.45rem;
  width: 100%;

  img {
    // width: 1.2rem;
    height: 0.4rem;

    &:nth-of-type(2) {
      margin: 0 0.24rem;
    }
  }

  p {
    color: #fff;
    padding: 0 0.21rem;
  }
}

.body_top_list_select {
  display: block;
  width: 6rem;
  margin: 0 auto;
  margin-top: 0.3rem;
}

.BTLS_list {
  display: flex;
  justify-content: flex-start;
}

.BTLS_list>div {
  margin-right: 0.4rem;
  color: #fff;
  font-size: 0.14rem;
  padding-bottom: 0.02rem;
}

.BTLS_listY {
  border-bottom: 0.02rem solid #fff;
}

.BTLS_listN {
  border-bottom: 0.02rem solid rgba(0, 0, 0, 0);
}

.BTLS_search {
  width: 100%;
  display: flex;
}

.BTLS_search_input {
  width: 5rem;
  padding: 0.16rem;
  background: #fff;
  font-size: 0.14rem;
  border: 0rem solid rgba(0, 0, 0, 0);
}

.BTLS_search_bottom {
  flex-grow: 1;
  background: #C01A26;
  display: flex;
  color: #fff;
  font-size: 0.14rem;
  align-items: center;
  justify-content: center;
}

.BTLS_search_bottom>img {
  width: 0.16rem;
  height: 0.16rem;
  margin-right: 0.03rem;
}

.BTLS_input {
  display: flex;
  width: 6rem;
  margin: 0 auto;
  margin-top: 0.12rem;
  border-radius: 0.1rem;
  overflow: hidden;
}

.body_main {
  width: 12.8rem;
  margin: 0 auto;
  position: relative;
  margin-top: 0.3rem;
}

.body_main_classify {
  background: #ffffff;
  box-shadow: 0rem 0.04rem 0.12rem 0rem rgba(190, 198, 210, 0.25);
  border-radius: 0.12rem;
  padding: 0.24rem;
}

.body_main_classify .bm_classifyTitle {
  font-size: 0.16rem;
  color: #333333;
  margin-bottom: 0.12rem;
}

.body_main_classify_span {
  display: flex;
  justify-content: left;
  flex-wrap: wrap;
}

.body_main_classify span {
  margin-top: 0.08rem;
  color: #86909c;
  font-size: 0.14rem;
  /* display: block; */
  padding: 0.04rem 0.14rem 0.04rem 0;
  white-space: nowrap;
  cursor: pointer;
}

.SL_hotSongwriter {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 0.7rem;
  margin-bottom: 0.3rem;
}

.SL_hotSongwriter_title {
  font-size: 0.24rem;
  color: #000;
}

.SL_hotSongwriter_click {
  font-size: 0.14rem;
  color: #333;
}

.body_bottom {
  display: flex;
  justify-content: center;
  margin-top: 0.4rem;
  margin-bottom: 0.5rem;
}

.body_bottom>div {
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  background: #ff6000;
  font-size: 0.14rem;
  color: #ffffff;
  line-height: 0.16rem;
  padding: 0.12rem 0.4rem;
}

.directionListY {
  background: rgba(255, 96, 0, 0.2);
  color: #C01A26 !important;
  border-radius: 1rem 1rem 1rem 1rem;
}

/* 图片样式 */
.SL_hotSongwriter_img_box1 {
  // background: #CCCCCC;
  display: flex;
  justify-content: space-between;
  // justify-content: flex-start;
  flex-wrap: wrap;

  .item {
    height: 2.4rem;
    background: #ccc;
  }

  .item_ {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
  }

  &>.item:nth-child(1),
  &>.item:nth-child(2) {
    width: 3.59rem;
  }

  &>.item:nth-child(3) {
    width: 1.6rem;
  }

  &>.item:nth-child(4) {
    width: 3.65rem;
  }

  &>.item:nth-child(5) {
    width: 9.03rem;
    margin-top: 0.12rem;
  }

  &>.item:nth-child(6) {
    width: 3.65rem;
    margin-top: 0.12rem;
  }
}

.SL_hotSongwriter_img_box1:after {
  // content: "";
  // width: 70%;
  // flex: auto;
  // margin-left: 20px;
}

.SL_hotSongwriter_img_box2 {
  // background: #CCCCCC;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  .item {
    height: 2.4rem;
    background: #ccc;
  }

  .item_ {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
  }

  &>.item:nth-child(1) {
    width: 1.59rem;
  }

  &>.item:nth-child(2),
  &>.item:nth-child(3),
  &>.item:nth-child(4) {
    width: 3.6rem;
  }

  &>.item:nth-child(5),
  &>.item:nth-child(6),
  &>.item:nth-child(7) {
    width: 2.93rem;
    margin-top: 0.12rem;
  }

  &>.item:nth-child(8) {
    margin-top: 0.12rem;
    width: 3.65rem;
  }
}
</style>
